export default "__VITE_ASSET__DvBaTHkh__"